import { render } from "./faq.vue?vue&type=template&id=3620ccd8&scoped=true&ts=true"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"

import "./faq.vue?vue&type=style&index=0&id=3620ccd8&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3620ccd8"]])

export default __exports__